'use client';

import PlausibleProvider from 'next-plausible';
import { HeroUIProvider } from '@heroui/react';

export default function Providers({ children }: { children: React.ReactNode }) {
  return <PlausibleProvider
    selfHosted={ true }
    enabled={ true }
    customDomain={ 'https://analytics.tools.boldmove.cz' }
    trackLocalhost={ false }
    taggedEvents={ true }
    domain={ process.env.NEXT_PUBLIC_DOMAIN ?? 'unknown.boldmove.cz' }
  >

    <HeroUIProvider>
      { children }
    </HeroUIProvider>
  </PlausibleProvider>;
}
